export const GRADUATION_MONTH_PATTERN = /^(0[1-9]|1[0-2])\/([1-9]\d{3})$/;

const SQL_DATE_PATTERN = /^([1-9]\d{3})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

const daysInMonth = (year: number, month: number): number => {
  const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  return days[month - 1];
};

export const isValidGraduationMonth = (value: unknown): value is string =>
  typeof value === 'string' && GRADUATION_MONTH_PATTERN.test(value.trim());

export const graduationMonthToSqlDate = (value: unknown): string | null => {
  if (!isValidGraduationMonth(value)) return null;

  const [, month, year] = value.trim().match(GRADUATION_MONTH_PATTERN) as RegExpMatchArray;
  const lastDay = daysInMonth(Number(year), Number(month));

  return `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
};

export const isValidSqlGraduationDate = (value: unknown): value is string => {
  if (typeof value !== 'string') return false;

  const match = value.trim().match(SQL_DATE_PATTERN);
  if (!match) return false;

  const [, year, month, day] = match;

  return Number(day) <= daysInMonth(Number(year), Number(month));
};
